import { PieChart, Pie, Cell } from 'recharts';

export const PieChartSimple = ({ data }: { data: { label: string; size: number; color: string }[] }) => {
  return (
    <PieChart width={150} height={150}>
      <Pie data={data} cx={70} cy={70} innerRadius={50} outerRadius={70} fill="#8884d8" paddingAngle={1} dataKey="size">
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={`var(--${entry.color})`} />
        ))}
      </Pie>
    </PieChart>
  );
};
